export default __webpack_public_path__ + "static/media/minecraft.7828f976.jpeg";